'use client';

import { cn } from '@/lib/utils';
import { InputHTMLAttributes, forwardRef } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import ErrorText from './ErrorText';

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    className?: string;
    register?: UseFormRegister<any>;
    error?: FieldError | string;
}

const Input = forwardRef<HTMLInputElement, CustomInputProps>((props, ref) => {
    const { className, required, type, register, error, ...inputProps } = props;

    return (
        <div className="flex flex-col relative">
            <input
                {...register}
                {...inputProps}
                ref={ref}
                type={type}
                className={cn(
                    'h-9 w-full border-b py-[10px] text-h6 font-medium text-black placeholder-dark-grey focus:border-brand focus:outline-none border-dark-grey placeholder-shown:border-grey bg-transparent rounded-none',
                    error && 'border-red-400',
                    className,
                )}
                placeholder={required ? `${inputProps.placeholder}*` : inputProps.placeholder}
                required={required}
            />
            {error && <ErrorText error={error} />}
        </div>
    );
});

Input.displayName = 'Input';

export default Input;
